// extracted by mini-css-extract-plugin
export default {"root":"SnackBar_root__HiPNe","error":"SnackBar_error__QpmaS","success":"SnackBar_success__SP0tz","info":"SnackBar_info__UJoIO"};